import { useMemo } from 'react';

const APP_STORE_BASE = 'https://apps.apple.com/app/apple-store/id6754414390';

/**
 * Builds an App Store URL with a dynamic `ct` parameter.
 * Appends utm_source, utm_campaign, and utm_medium from the page URL when present.
 *
 * Examples:
 *   No UTMs           → ct=intake-quiz
 *   ?utm_source=newsletter → ct=intake-quiz-newsletter
 *   ?utm_source=newsletter&utm_campaign=spring&utm_medium=email → ct=intake-quiz-newsletter-spring-email
 */
export function useAppStoreUrl(defaultCt) {
  return useMemo(() => {
    const parts = [defaultCt];

    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const source = params.get('utm_source');
      const campaign = params.get('utm_campaign');
      const medium = params.get('utm_medium');
      if (source) parts.push(source);
      if (campaign) parts.push(campaign);
      if (medium) parts.push(medium);
    }

    return `${APP_STORE_BASE}?pt=329394&ct=${parts.join('-')}&mt=8`;
  }, [defaultCt]);
}
